// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import ChatHistoryJs from "./ChatHistory.js";
import * as Utils$SimonKjellberg from "../Utils.bs.js";
import ChatMessageInputJs from "./ChatMessageInput.js";
import * as Heading$SimonKjellberg from "./Heading.bs.js";
import * as Terminal$SimonKjellberg from "./Terminal.bs.js";

var make = ChatHistoryJs;

var ChatHistory = {
  make: make
};

var make$1 = ChatMessageInputJs;

var ChatMessageInput = {
  make: make$1
};

var styles = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexDirection("column"),
        tl: {
          hd: Css.unsafe("maxHeight", "inherit"),
          tl: /* [] */0
        }
      }
    });

function Chat(Props) {
  return React.createElement("section", undefined, React.createElement(Heading$SimonKjellberg.make, {
                  level: "Level2",
                  children: Utils$SimonKjellberg.str("Slack")
                }), React.createElement(Terminal$SimonKjellberg.make, {
                  children: React.createElement("div", {
                        className: styles
                      }, React.createElement(make, {}), React.createElement(make$1, {}))
                }));
}

var make$2 = Chat;

var $$default = Chat;

export {
  ChatHistory ,
  ChatMessageInput ,
  styles ,
  make$2 as make,
  $$default ,
  $$default as default,
  
}
/* make Not a pure module */
